import { useEffect, useRef, useState } from "react";
import { InputAdornment, TextField } from "@mui/material";
import {
  formatPercentageInput,
  roundPercentage,
  sanitizePercentageInput,
} from "../utils/numericInputs";

export default function PercentageField({
  label,
  value,
  onChange,
  disabled = false,
  sx,
}) {
  const focusedRef = useRef(false);
  const [displayValue, setDisplayValue] = useState(formatPercentageInput(value));

  useEffect(() => {
    if (!focusedRef.current) {
      setDisplayValue(formatPercentageInput(value));
    }
  }, [value]);

  function handleChange(event) {
    const nextText = sanitizePercentageInput(event.target.value);
    setDisplayValue(nextText);
    onChange(roundPercentage(nextText));
  }

  function handleFocus(event) {
    focusedRef.current = true;
    event.target.select();
  }

  function handleBlur() {
    focusedRef.current = false;
    setDisplayValue(formatPercentageInput(value));
  }

  return (
    <TextField
      label={label}
      value={displayValue}
      onChange={handleChange}
      onFocus={handleFocus}
      onBlur={handleBlur}
      disabled={disabled}
      slotProps={{
        input: {
          endAdornment: <InputAdornment position="end">%</InputAdornment>,
        },
        htmlInput: {
          inputMode: "decimal",
          "aria-label": `${label} com duas casas decimais`,
        },
      }}
      sx={sx}
    />
  );
}
